export default __webpack_public_path__ + "saha@2x.f7b7807c.png";